import React from 'react';
import { Tabs as AntdTabs } from 'antd';
import { Card, Tooltip } from '../index';
import styles from './index.module.scss';
import { ifValueExists } from '@utils/utils';
import SortDropdown from '@components-web/sort-dropdown';

const Tabs = ({
  tabsList = [],
  tabStyle = {},
  activeKey,
  tabPosition = 'top',
  onTabClick = () => { },
  contentClassName = '',
  defaultTabBarExtraContent = () => { },
  getAction = () => { },
  customSortOptions = [],
}) => {
  const tabBarExtraContent = () => {
    const selectedTab = tabsList.find((tab) => tab.key == activeKey);
    if (selectedTab) {
      return <>{getAction(selectedTab) ?? defaultTabBarExtraContent()}</>;
    }
    return defaultTabBarExtraContent();
  };

  return (
    <>
      {!!customSortOptions?.length && <SortDropdown sortOptions={customSortOptions} />}
      <Card rootClassName={styles.tabsCard} bordered>
        <AntdTabs
          {...(ifValueExists(activeKey)
            ? { activeKey: String(activeKey) }
            : { defaultActiveKey: String(tabsList[0]?.key) })}
          style={tabStyle}
          tabPosition={tabPosition}
          onTabClick={onTabClick}
          tabBarExtraContent={tabBarExtraContent()}
          items={React.useMemo(() => tabsList
            ?.filter((item) => item?.show)
            ?.map((tab) => {
              return {
                label: <Tooltip title={tab?.tooltipText}>{tab.label}</Tooltip>,
                key: String(tab.key),
                children: <div className={contentClassName}>{tab.children}</div>,
                disabled: tab?.disabled,
              };
            }), [tabsList, contentClassName])}
          destroyOnHidden={true}
        />
      </Card>
    </>
  );
};

export default Tabs;
